import { strategyTypesEnum } from "./strategy";
import supportLanguageListJson from "./supportLanguageList.json";
import { LanguageTypeItem } from "../api/common/model";

/**
 * 业务线
 */
export enum BusinessLineEnum {
  SPOT_BL = 1,
  CONTRACT_BL = 2,
  /**
   * 废弃
   */
  MIX_CONTRACT_BL = 3,
  OPTION_BL = 4,
  OTC_BL = 5,
  FINANCIAL_BL = 6,
  SPOT_MIX_CONTRACT = 7,
  /**
   * SUSDT混合合约，即USDT专业合约模拟盘，仅支持SUSDT保证金
   */
  S_USDT_MIX_CONTRACT_BL = 8,
  /**
   * SUSD混合合约，即混合合约的模拟盘
   */
  S_USD_MIX_CONTRACT_BL = 9,
  /**
   * USDT混合合约，即USDT专业合约，仅支持USDT保证金
   */
  USDT_MIX_CONTRACT_BL = 10,
  /**
   * USD混合合约，即混合合约
   * 币本位合约
   */
  USD_MIX_CONTRACT_BL = 11,
  /**
   * USDC合约，保证金仅支持usdc，usd计价
   */
  USDC_MIX_CONTRACT_BL = 12,
  S_USDC_MIX_CONTRACT_BL = 13, // USDC模拟，保证金仅支持susdc，usd计价
  /**
   * 杠杆
   */
  MARGIN_BL = 23,
}

// kline 和 trading view 的缓存版本号
/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum KLineAndTradingViewInfoVersion {
  FUTURES = "1.0",
  SPOT = "1.0",
}
/* eslint-enable @typescript-eslint/no-duplicate-enum-values */

/**
 * 业务线Name（费率页面业务线下拉框）
 */
export enum BusinessLineToShortName {
  SUSDT = 8, // SUSDT混合合约，即USDT专业合约模拟盘，仅支持SUSDT保证金
  SUSD = 9, // SUSD混合合约，即混合合约的模拟盘
  USDT = 10, // USDT混合合约，即USDT专业合约，仅支持USDT保证金
  USD = 11, // USD混合合约，即混合合约
  USDC = 12, // USDC合约，保证金仅支持usdc，usd计价
  SUSDC = 13, // USDC模拟，保证金仅支持susdc，usd计价
}

/**
 * 业务线列表（费率页面业务线下拉框）
 */
export const BusinessLineToShortNameList = {
  SUSDT: BusinessLineEnum.S_USDT_MIX_CONTRACT_BL,
  SUSD: BusinessLineEnum.S_USD_MIX_CONTRACT_BL,
  SUSDC: BusinessLineEnum.S_USDC_MIX_CONTRACT_BL,
};

export const RouteToBusinessLine = {
  usdt: BusinessLineEnum.USDT_MIX_CONTRACT_BL,
  usd: BusinessLineEnum.USD_MIX_CONTRACT_BL,
  susdt: BusinessLineEnum.S_USDT_MIX_CONTRACT_BL,
  susd: BusinessLineEnum.S_USD_MIX_CONTRACT_BL,
  usdc: BusinessLineEnum.USDC_MIX_CONTRACT_BL,
  susdc: BusinessLineEnum.S_USDC_MIX_CONTRACT_BL,
  "future-strategy": BusinessLineEnum.USDT_MIX_CONTRACT_BL,
  "spot-strategy": BusinessLineEnum.SPOT_BL,
};

/**
 * 业务线简写
 */
export const BusinessLineShortName = {
  default: "mc",
  [BusinessLineEnum.SPOT_BL]: "spbl",
  [BusinessLineEnum.USDT_MIX_CONTRACT_BL]: "umcbl",
  [BusinessLineEnum.USD_MIX_CONTRACT_BL]: "dmcbl",
  [BusinessLineEnum.S_USDT_MIX_CONTRACT_BL]: "sumcbl",
  [BusinessLineEnum.S_USD_MIX_CONTRACT_BL]: "sdmcbl",
  [BusinessLineEnum.USDC_MIX_CONTRACT_BL]: "cmcbl",
  [BusinessLineEnum.S_USDC_MIX_CONTRACT_BL]: "scmcbl",
};

/**
 * 不同业务线的没人instType
 */
export const DefaultInstTypeEnum = {
  [BusinessLineEnum.SPOT_BL]: "sp",
  [BusinessLineEnum.USDT_MIX_CONTRACT_BL]: "umcbl",
};

export const BusinessLineToRoute = {
  [BusinessLineEnum.USDT_MIX_CONTRACT_BL]: "usdt",
  [BusinessLineEnum.USD_MIX_CONTRACT_BL]: "usd",
  [BusinessLineEnum.S_USDT_MIX_CONTRACT_BL]: "susdt",
  [BusinessLineEnum.S_USD_MIX_CONTRACT_BL]: "susd",
  [BusinessLineEnum.USDC_MIX_CONTRACT_BL]: "usdc",
  [BusinessLineEnum.S_USDC_MIX_CONTRACT_BL]: "susdc",
};

/**
 * 每个业务线对应的计价币ID
 */
export const BusinessLineToQuoteToken = {
  [BusinessLineEnum.USDT_MIX_CONTRACT_BL]: "USDT",
  [BusinessLineEnum.USD_MIX_CONTRACT_BL]: "USD",
  [BusinessLineEnum.S_USDT_MIX_CONTRACT_BL]: "SUSDT",
  [BusinessLineEnum.S_USD_MIX_CONTRACT_BL]: "SUSD",
  [BusinessLineEnum.USDC_MIX_CONTRACT_BL]: "USD",
  [BusinessLineEnum.S_USDC_MIX_CONTRACT_BL]: "SUSD",
};

/**
 * 终端类型
 */
export enum EnterPointSource {
  WEB = 1,
  APP = 2,
  API = 3,
  SYS = 4,
}

/**
 * 业务源
 */
export enum BusinessSource {
  NORMAL = 0, //限价委托
  STOP_PROFIT = 2,
  STOP_LOSS = 3,
  MARKET = 10, // 市价普通，市价委托时BusinessSource字段使用该值
  LIMIT_SURPLUS = 23,
  LIMIT_LOSS = 24,
  ICE_LIMIT = 87,
}

/**
 * 当前默认的二级业务线用该值
 */
export const SecondBusinessLine = "N/A";

export const TokenToSymbol = {
  USDT: "₮",
  USD: "$",
  SUSDT: "₮",
  SUSD: "$",
};

// 默认的语言列表
export const supportLanguageList: LanguageTypeItem[] = supportLanguageListJson;

// 挂单余额不足相关code
export const StrategyTypeEnum = {
  DEFAULT: 0,
  POSITIVE_GRID: 1,
  NEGATIVE_GRID: 2,
  NEUTRAL_GRID: 3,
  CTA: 4,
  TV: 5,
};

export const CommonStrategyTypeLocale = {
  [StrategyTypeEnum.DEFAULT]: "strategy_grid_text.strategy_trade",
};

/**
 * 币币各种策略的名称
 * @type {{'[StrategyTypeEnum.NEGATIVE_GRID]': string}}
 */
export const SpotStrategyTypeLocale = {
  [StrategyTypeEnum.POSITIVE_GRID]: "strategy_grid_text.strategy_type_text_1",
  [StrategyTypeEnum.NEGATIVE_GRID]: "strategy_grid_text.backward_grid",
  [StrategyTypeEnum.NEUTRAL_GRID]: "neutral.title",
};
export const FutureStrategyTypeLocale = {
  [StrategyTypeEnum.POSITIVE_GRID]: "strategy_grid_text.contract_long_grid",
  [StrategyTypeEnum.NEGATIVE_GRID]: "strategy_grid_text.contract_short_grid",
  [StrategyTypeEnum.NEUTRAL_GRID]: "neutral.title",
};
export const FutureDCAStrategyTypeLocale = {
  [StrategyTypeEnum.POSITIVE_GRID]: "dca.longdca",
  [StrategyTypeEnum.NEGATIVE_GRID]: "dca.shortdca",
};
export const SpotDCAStrategyTypeLocale = {
  [StrategyTypeEnum.POSITIVE_GRID]: "dca.normaldca",
  [StrategyTypeEnum.NEGATIVE_GRID]: "dca.reverseldca",
};
export const AutoInvesStrategyTypeLocale = {
  [strategyTypesEnum["timing"]]: "auto_invest.title",
};
export const HoardStrategyTypeLocale = {
  [strategyTypesEnum["hoard"]]: "strategy_hoard_coins.title",
};
export const SpotMoonStrategyTypeLocale = {
  [StrategyTypeEnum.POSITIVE_GRID]: "moon.forward_moon",
  [StrategyTypeEnum.NEGATIVE_GRID]: "moon.backward_moon",
};
export const FutureMoonStrategyTypeLocale = {
  [StrategyTypeEnum.POSITIVE_GRID]: "moon.contract_long",
  [StrategyTypeEnum.NEGATIVE_GRID]: "moon.contract_short",
};
/**
 * 获取策略的名称
 * @param businessLine
 * @param strategyType
 * @param isDca
 * @returns {*}
 */
export function getStrategyTypeLocaleKey(
  businessLine,
  strategyType,
  isDca = false,
  subcategory = 0
) {
  if (strategyType === strategyTypesEnum["timing"]) {
    return AutoInvesStrategyTypeLocale[strategyType];
  }
  if (strategyType === strategyTypesEnum["hoard"]) {
    return AutoInvesStrategyTypeLocale[strategyType];
  }
  if (strategyType === 0 || !strategyType) {
    return CommonStrategyTypeLocale[StrategyTypeEnum.DEFAULT];
  } else {
    switch (businessLine) {
      case BusinessLineEnum.SPOT_BL:
        return isDca
          ? SpotDCAStrategyTypeLocale[strategyType]
          : subcategory
            ? SpotMoonStrategyTypeLocale[strategyType]
            : SpotStrategyTypeLocale[strategyType];
      case BusinessLineEnum.USDT_MIX_CONTRACT_BL:
        return isDca
          ? FutureDCAStrategyTypeLocale[strategyType]
          : subcategory
            ? FutureMoonStrategyTypeLocale[strategyType]
            : FutureStrategyTypeLocale[strategyType];
      default:
        return CommonStrategyTypeLocale[StrategyTypeEnum.DEFAULT];
    }
  }
}

/**
 * 获取策略的名称
 * @param businessLine
 * @param strategyType
 * @param isDca
 * @returns {*}
 */
export function getOnlyStrategyTypeName({
  businessLine,
  strategyType,
  isDca = false,
  isCta = false,
  isGrid = false,
  isWise = false,
  isAutoInvest = false,
  isTV = false,
  isMoon = false,
  subcategory = 0,
}) {
  if (strategyType === strategyTypesEnum["timing"]) {
    return AutoInvesStrategyTypeLocale[strategyType];
  }
  if (strategyType === 0 || !strategyType) {
    return CommonStrategyTypeLocale[StrategyTypeEnum.DEFAULT];
  } else {
    switch (businessLine) {
      case BusinessLineEnum.SPOT_BL:
        if (isDca) return "strategy.spot.dca";
        if (isGrid)
          return subcategory ? "strategy.spot.moon" : "strategy.spot.grid";
        if (isCta) return "strategy.spot.cta";
        if (isAutoInvest) return "auto_invest.title";
        if (isMoon) return "strategy.spot.moon";
        return CommonStrategyTypeLocale[StrategyTypeEnum.DEFAULT];
      case BusinessLineEnum.USDT_MIX_CONTRACT_BL:
        if (isDca) return "strategy.future.dca";
        if (isGrid)
          return subcategory ? "strategy.future.moon" : "strategy.future.grid";
        if (isCta) return "strategy.future.cta";
        if (isWise) return "strategy.future.wise";
        if (isTV) return "strategy.sign.furture_title";
        if (isMoon) return "strategy.future.moon";
        return CommonStrategyTypeLocale[StrategyTypeEnum.DEFAULT];
      default:
        return CommonStrategyTypeLocale[StrategyTypeEnum.DEFAULT];
    }
  }
}

/**
 * 获取策略的名称
 * @param businessLine
 * @param strategyType
 * @param isDca
 * @returns {*}
 */
export function getStrategyTypeName({ businessLine, strategyType }) {
  switch (businessLine) {
    case BusinessLineEnum.SPOT_BL:
      if (strategyType === "dca") return "strategy.spot.dca";
      if (strategyType === "grid") return "strategy.spot.grid";
      if (strategyType === "cta") return "strategy.spot.cta";
      if (strategyType === "hoard") return "strategy_hoard_coins.title";
      if (strategyType === "timing") return "auto_invest.title";
      if (strategyType === "moon") return "strategy.spot.moon";
      return CommonStrategyTypeLocale[StrategyTypeEnum.DEFAULT];
    case BusinessLineEnum.USDT_MIX_CONTRACT_BL:
      if (strategyType === "dca") return "strategy.future.dca";
      if (strategyType === "grid") return "strategy.future.grid";
      if (strategyType === "cta") return "strategy.future.cta";
      if (strategyType === "wise") return "strategy.future.wise";
      if (strategyType === "moon") return "strategy.future.moon";
      if (strategyType === "tv") return "strategy.sign.furture_title";
      return CommonStrategyTypeLocale[StrategyTypeEnum.DEFAULT];
    default:
      return CommonStrategyTypeLocale[StrategyTypeEnum.DEFAULT];
  }
  // }
}

export const INSUFFICIENT_CODE_LIST = [
  "balance_available_not_enough",
  "contract_balance_is_not_enough",
  "mark_price_order_fail",
];

/**
 * 资金划转账户类型
 */
export enum AccountTypeEnum {
  SPOT = 1, // 现货
  OTC = 4,
  USDT_MIX = 6, // U本位
  USD_MIX = 7, // 币本位
  USDC_MIX = 8, // USDC本位
  SPOT_MARGIN_CROSS = 10, // 现货杠杆全仓
  SPOT_MARGIN_ISOLATED = 11, // 现货杠杆逐仓
}

export const BusinessLineToAccountTypeMap = {
  [BusinessLineEnum.SPOT_BL]: AccountTypeEnum.SPOT,
  [BusinessLineEnum.USDT_MIX_CONTRACT_BL]: AccountTypeEnum.USDT_MIX,
  [BusinessLineEnum.USD_MIX_CONTRACT_BL]: AccountTypeEnum.USD_MIX,
  [BusinessLineEnum.USDC_MIX_CONTRACT_BL]: AccountTypeEnum.USDC_MIX,
};

export const BusinessSourceEnumMap = {
  "36": "dca.longdca",
  "37": "dca.shortdca",
};

export enum PriceTagEnum {
  MarketPrice,
  MarkPrice,
}
/**
 * 涨跌幅时区key
 */
export const ChangeTimezoneLocalstorageKey = "cointr:change:timezone";

/**
 * 目前仅支持-12-0-+12共25个时区，小数点等特殊时区暂不考虑
 * 数据与getTimezoneOffset对应
 */
export const SupportedChangeTimezone = [
  -720, -660, -600, -540, -480, -420, -360, -300, -240, -180, -120, -60, 0, 60,
  120, 180, 240, 300, 360, 420, 480, 540, 600, 660, 720,
];

export const Last24HOption = "last24h";

/**
 * 获取时区显示
 * getTimezoneOffset -480 => 8
 * @param offset
 * @param local
 */
export function getTimezoneDisplayByOffset(offset: number, local?: string) {
  let n = -offset / 60;
  return `00:00 (UTC${(n >= 0 ? "+" : "") + n}${local ? `, ${local}` : ""})`;
}

/**
 * 转换为后端使用参数
 * getTimezoneOffset -480 => 28800
 * @param offset
 */
export function getTimezonePostParamValue(offset: number) {
  return -offset * 60;
}

export const localMap = {
  en: "en_US",
  tr: "tr_TR",
};

export const BitDesignLocaleMap = {
  ...localMap,
  ar: "ar_EG",
};

export const DEFAULT_CURRENCY = "USD";

export enum FutureBusinessName {
  USDT = "usdt",
  SUSDT = "susdt",
  USD = "usd",
  SUSD = "susd",
  USDC = "usdc",
  SUSDC = "SUSDC",
}

export const BusinessNameSuffixMap = {
  [FutureBusinessName.USDT]: "_UMCBL",
  [FutureBusinessName.USD]: "_DMCBL",
  [FutureBusinessName.USDC]: "_CMCBL",
  [FutureBusinessName.SUSDT]: "_SUMCBL",
  [FutureBusinessName.SUSD]: "_SDMCBL",
  [FutureBusinessName.SUSDC]: "_SCMCBL",
};

export const BusinessNameSuffixMapIndex = [
  { symbol: "_UMCBL", line: 10 },
  { symbol: "_DMCBL", line: 11 },
  { symbol: "_CMCBL", line: 12 },
  { symbol: "_SUMCBL", line: 8 },
  { symbol: "_SDMCBL", line: 9 },
  { symbol: "_SCMCBL", line: 13 },
];

export enum SITE_TYPE {
  "beta" = "beta",
  "sjk" = "sjk",
  "cn" = "cn",
  "com" = "com",
}

export enum STRATEGY_ENTITY_KEYS {
  // 确认参数仅包括以下内容
  STRATEGY_NUM = "strategyNum",
  UP_LIMIT_PRICE = "strategyMaxPrice",
  DOWN_LIMIT_PRICE = "strategyMinPrice",
  TOKEN_BASE_INVEST_AMOUNT = "tokenBaseInvestAmount",
  TOKEN_QUOTE_INVEST_AMOUNT = "tokenQuoteInvestAmount",
  STRATEGY_MODEL = "strategyModel",
  STRATEGY_TRIGGER_PRICE = "triggerPrice",
  // 提交参数还包括以下内容
  STRATEGY_ATTRIBUTE = "strategyAttribute",
  STRATEGY_MODEL_GRADE = "strategyModelGrade",
  STRATEGY_TAKE_PROFIT_PRICE = "stopProfitPrice",
  STRATEGY_STOP_PRICE = "stopLossPrice",
  GRID_TYPE = "gridType",
  INVEST_TOKENS = "investTokens",
  END_OPERATE = "endOperate",
  TOKEN_ID = "tokenId",
  MARGIN_MODE = "marginMode",
  LEVERAGE = "leverage",
}

export const MAIN_STUDY = ["MA", "EMA", "BOLL"];
export const SECONDARY_STUDY = [
  "VOL",
  "MACD",
  "KDJ",
  "RSI",
  "BIAS",
  "BRAR",
  "CCI",
  "DMI",
  "CR",
  "PSY",
  "DMA",
  "TRIX",
  "OBV",
  "VR",
  "WR",
  "MTM",
  "EMV",
  "SAR",
];

export const isCnSite = process.env.SITE_TYPE === SITE_TYPE.cn;

export const BENEFIT_SHARE_TYPE = 1;
export const BENEFIT_SHARE_TASK_TYPE = 13;

export enum ContractSymbolTypeEnums {
  // 0->全部 1->永续 2->交割
  ALL = 0,
  PERPETUAL = 1,
  DELIVERY = 2,
}

// K线区间统计
export const KLINE_INTERVAL_HIDE = "kline_interval_hide";
